import { filter } from "lodash";

export function getLocalSearchResults(hotels, destinations, criteria) {
    let results = { 'hotels':[], 'destinations':[] };
    let hotelsCount = 0;
    let destinationsCount = 0;
    let limit = 5;

    results.destinations = filter(destinations, (destination => {
        if (new RegExp(`${criteria}`, 'gi').test(destination.name) && destinationsCount <= limit) {
            destinationsCount ++;
            return true;
        }
        return false;
    }));

    results.hotels = filter(hotels, (hotel => {
        if (new RegExp(`${criteria}`, 'gi').test(hotel.name) && hotelsCount <= limit) {
            hotelsCount ++;
            return true;
        }
        return false;
    }));

    if (results.hotels.length === 0) {
        results.hotels = results.destinations.reduce((previousValue, currentValue) => {
            let _hotels = currentValue.hotels.filter(hotel => {
                hotelsCount ++;
                return hotelsCount <= limit;
            });
            return previousValue.concat(_hotels);
        }, []);
    }

    return results;
}
